import React from "react";
import { connect } from "react-redux";
import axios from "axios";
import routes from "../../../assets/apiRoutes.json"
import { Button } from "devextreme-react/button";
import Toolbar, { Item } from "devextreme-react/toolbar";
import { LoadIndicator } from "devextreme-react/load-indicator";
import { createStore } from "devextreme-aspnet-data-nojquery";
import { Lookup as LookupBox, DropDownOptions } from "devextreme-react/lookup";
import Form, {
  SimpleItem, Label
} from 'devextreme-react/form';
import { alert } from 'devextreme/ui/dialog';
import { downloadReportFile } from "../../../common/Utils";

let accessToken = "";
const productionLotSelectBox = React.createRef();
const form = React.createRef();

class ManualBagTags extends React.Component {
  constructor(props) {
    super(props);

    accessToken = props.oidc.user.access_token;

    this.state = {
      loadIndicatorVisible: false,
      productionlot: "",
      order: {
        rowid: '00000000-0000-0000-0000-000000000000',
        customername: '',
        salesorder: '',
        salesorderline: 0,
        orderquantity: 0.0,
        facility: '',
        custtype: '',
        prodlot: '',
        speciescode: '',
        Lastupdatedatetime: new Date(),
        companyid: '',
        hdrcreationdate: new Date(),
        salesitem: '',
        color: '',
        symbol: '',
        comment: '',
        prodtype: '',
        species: '',
        kittstocktype: '',
        kittcells: '',
        celltype: '',
        oversow: '',
        seedsource: '',
        commonname: '',
        stratdays: 0,
        wetstratdays: 0,
        drystratdays: 0,
        seqnumber: 0,
        receiving: 0,
        soakin: '',
        treat: '',
        sowdate: new Date(),
        seedspercell: 0,
        cutseedspercell: 0,
        iscut: false,
        egerm: 0,
        salesrep: '',
        isreleased: false,
        releaseddate: new Date(),
        islotassigned: false,
        lotassigneddate: new Date(),
        isstratpending: false,
        stratpendingdate: new Date(),
        isonpullorder: false.valueOf,
        onpullorderdate: new Date(),
        pullordernumber: 0,
        isinwetstrat: false,
        inwetstratdate: new Date(),
        stratdate: new Date(),
        orderduedate: new Date(),
        endstratdate: new Date(),
        stratrowbayshelf: '',
        isselectdrylots: false,
        selectdrylotsdate: new Date(),
        selectdrylotsnumber: 0,
        drystratcomplete: false,
        drystratcompletedate: new Date(),
        isshipped: false,
        shippeddate: new Date(),
        dryStratDoneDate: new Date(),
        newwetweight: 0,
        lotcutdate: new Date(),
        newbags: 0,
        newseedslb: 0,
        fieldname: '',
        seedplantcomment: '',
        selecteddetailrowid: '00000000-0000-0000-0000-000000000000',
        selecteddetailissueqty: 0.0,
        selecteddetailchangedissueqty: 0.0,
        selecteddetailavailable: 0.0,
        selecteddetailnetavailable: 0.0,
        selecteddetailchangeqty: 0.0,
        selecteddetailnewavailable: 0.0,
        selecteddetailcurrentqty: 0.0,
        selecteddetailseeditem: '',
        selecteddetailseedlot: '',
        selecteddetailgerm: 0.0,
        selecteddetailpurity: 0.0,
        selecteddetailcellstosow: 0.0,
        selecteddetailseedslb: 0,
        selecteddetailrevseedslb: 0,
        selecteddetailpad: 0.0,
        selecteddetailrequired: 0.0,
        selecteddetailbalance: 0.0,
        newseedspercell: 0.0,
        selecteddetailnewissueqty: 0.0,
        selecteddetailplsperlb: 0,
        selecteddetailpktreeslb: 0,
        selecteddetailpktrees: 0,
        selecteddetailallpktrees: 0,
        imagedata: 'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAIEAAACBCAIAAABowk4HAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAAJcEhZcwAAEnQAABJ0Ad5mH3gAAAEwSURBVHhe7dExAQAgDMCwgX/P48FDnuapgJ7dnVD3N04PvB54PfB64PXA64HXA68HXg+8Hng98Hrg9cDrgdcDrwdeD7weeD3weuD1wOuB1wOvB14PvB54PfB64PXA64HXA68HXg+8Hng98Hrg9cDrgdcDrwdeD7weeD3weuD1wOuB1wOvB14PvB54PfB64PXA64HXA68HXg+8Hng98Hrg9cDrgdcDrwdeD7weeD3weuD1wOuB1wOvB14PvB54PfB64PXA64HXA68HXg+8Hng98Hrg9cDrgdcDrwdeD7weeD3weuD1wOuB1wOvB14PvB54PfB64PXA64HXA68HXg+8Hng98Hrg9cDrgdcDrwdeD7weeD3weuD1wOuB1wOvB14PvB54PfB64PXA64HXA23mAayHA/8b+LUIAAAAAElFTkSuQmCC',
        issueqtysum: 0.0,
        selectedseedpercell: 0.0,
        poundsperbag: 3.0,
        poundslastbag: 0.0,
        totalbags: 0,
        newWeight: 0,
      }
    };

    this.previewButtonClicked = this.previewButtonClicked.bind(this);
    this.resetButtonClicked = this.resetButtonClicked.bind(this);
    this.productionLotChanged = this.productionLotChanged.bind(this);
    this.formFieldChanged = this.formFieldChanged.bind(this);

    this.productionLotDataSource = createStore({
      loadUrl: `${window._env_.REACT_APP_APIS}/${routes.master_records.GetProductionLots}`,
      onBeforeSend: function (method, ajaxOptions) {
        ajaxOptions.headers = {
          Authorization: `Bearer ${accessToken}`
        };
      }
    });

    this.disabledEditorOptions = {
      readOnly: true
    }

  }

  render() {
    return (
      <div style={{ marginBottom: "10px" }}>
        {/* Title + Controls Container */}
        <div
          style={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "flex-start",
            backgroundColor: "rgb(240, 241, 239)",
            padding: "10px",
            gap: "20px",
            flexWrap: "wrap"
          }}
        >
          {/* Title */}
          <h6
            style={{
              color: window._env_.Color2,
              margin: 0
            }}
          >
            Manual Bag Tags Report
          </h6>

          {/* Controls */}
          <div
            style={{
              display: "flex",
              alignItems: "flex-start",
              gap: "10px",
              flexWrap: "wrap"
            }}
          >
            <LookupBox
              ref={productionLotSelectBox}
              placeholder="Production Lot"
              dataSource={this.productionLotDataSource}
              valueExpr="prodlot"
              displayExpr="bareRootPickList"
              onValueChanged={this.productionLotChanged}
              searchEnabled={true}
              showClearButton={true}
              width={300}
            >
              <DropDownOptions hideOnOutsideClick={true} width={500} />
            </LookupBox>

            <Button
              text="Reset"
              type="default"
              onClick={this.resetButtonClicked}
            />

            <Button type="default" onClick={this.previewButtonClicked}>
              <LoadIndicator
                style={{
                  height: "20px",
                  width: "20px",
                  verticalAlign: "middle",
                  marginRight: "5px",
                }}
                visible={this.state.loadIndicatorVisible}
              />
              <span className="dx-button-text">Preview</span>
            </Button>
          </div>
        </div>
        <Form
          ref={form}
          style={{ marginTop: "10px" }}
          labelMode="static"
          labelLocation="left"
          onFieldDataChanged={this.formFieldChanged}
          formData={this.state.order}
          minColWidth={100}
          colCount={3}>
          <SimpleItem dataField="customername" editorOptions={this.disabledEditorOptions}><Label text="Customer Name"></Label></SimpleItem>
          <SimpleItem dataField="orderquantity" editorOptions={this.disabledEditorOptions}><Label text="Order Quantity"></Label></SimpleItem>
          <SimpleItem dataField="issueqtysum"><Label text="Total Pounds"></Label></SimpleItem>
          <SimpleItem dataField="prodlot" editorOptions={this.disabledEditorOptions}><Label text="Production Lot"></Label></SimpleItem>
          <SimpleItem dataField="salesitem" editorOptions={this.disabledEditorOptions}><Label text="Sales Item"></Label></SimpleItem>
          <SimpleItem dataField="poundsperbag"><Label text="Pounds per Bag"></Label></SimpleItem>
          <SimpleItem dataField="species" editorOptions={this.disabledEditorOptions}><Label text="Species"></Label></SimpleItem>
          <SimpleItem dataField="speciescode" editorOptions={this.disabledEditorOptions}><Label text="Species Code"></Label></SimpleItem>
          <SimpleItem dataField="poundslastbag"><Label text="Pounds last Bag"></Label></SimpleItem>
          <SimpleItem dataField="color" editorOptions={this.disabledEditorOptions}><Label text="Color"></Label></SimpleItem>
          <SimpleItem dataField="pullordernumber" editorOptions={this.disabledEditorOptions}><Label text="Pull Order Numnber"></Label></SimpleItem>
          <SimpleItem dataField="totalbags"><Label text="Number of Bags"></Label></SimpleItem>
          <SimpleItem dataField="symbol" editorOptions={this.disabledEditorOptions}><Label text="Symbol"></Label></SimpleItem>
          <SimpleItem dataField="newWeight" editorOptions={this.disabledEditorOptions}><Label text="Net Weight Pounds"></Label></SimpleItem>
          <SimpleItem dataField="seedspercell" editorOptions={this.disabledEditorOptions}><Label text="Original Seeds/Cell"></Label></SimpleItem>
          <SimpleItem dataField="cutseedspercell" editorOptions={this.disabledEditorOptions}><Label text="Cut Seeds/Cell"></Label></SimpleItem>
          <SimpleItem dataField="iscut" editorOptions={this.disabledEditorOptions}><Label text="Is Cut"></Label></SimpleItem>
        </Form>
      </div>
    );
  }

  productionLotChanged(e) {
    this.setState({
      productionlot: e.value,
    });

    this.GetOrderData(e.value);

  }

  formFieldChanged(e) {

    if (e.dataField === "poundsperbag" || e.dataField === "issueqtysum") {
      var totalbags = Math.floor(this.state.order.issueqtysum / this.state.order.poundsperbag) + (this.state.order.issueqtysum - (this.state.order.issueqtysum / this.state.order.poundsperbag) != 0 ? 1 : 0);
      var order = { ...this.state.order };
      order.totalbags = totalbags;
      this.setState({ order });
      form.current.instance().repaint();
    }
  }

  resetButtonClicked() {
    this.setState({
      productionlot: ""
    });
    productionLotSelectBox.current.instance().reset();
  }

  previewButtonClicked() {
    if (this.state.order.iscut && (this.state.order.cutseedspercell === 0 || this.state.order.cutseedspercell === null || this.state.order.cutseedspercell === undefined)) {
      alert('The cut seed value is missing.', 'Error');
      return;
    }

    this.setState({
      loadIndicatorVisible: true
    });
    var that = this;
    var request = new Object();
    request.rowid = this.state.order.rowid;
    request.poundsperbag = this.state.order.poundsperbag;
    request.poundslastbag = this.state.order.poundslastbag;
    request.totalbags = this.state.order.totalbags;
    request.issueqty = this.state.order.issueqtysum;
    request.screenName = 'ManualBagTagsReport';

    axios.post
      (
        `${window._env_.REACT_APP_APIS}/${routes.master_records.GenerateBagTagsReport}`, request,
        {
          headers: {
            "Content-Type": "application/json",
            access_token: accessToken,
          },
        }
      )
      .then((res) => {
        if (res.data.isSuccess) {
          // Returned so the loader stays up until the file has downloaded.
          return downloadReportFile(res.data.fileName, accessToken);
        }

      })
      .catch((err) => {
        alert(err, "Error");
      })
      .finally(() => {
        this.setState({
          loadIndicatorVisible: false,
        });
      });
  }

  GetOrderData(productionlot) {
    axios
      .get(
        `${window._env_.REACT_APP_APIS}/${routes.master_records.GetMasterOrder}?productionLot=${productionlot}`,
        {
          headers: {
            "Content-Type": "application/json",
            access_token: accessToken,
          },
        }
      )
      .then((res) => {

        var totalbags = Math.floor(res.data.issueqtysum / res.data.poundsperbag) + (res.data.issueqtysum - (res.data.issueqtysum / res.data.poundsperbag) != 0 ? 1 : 0);
        res.data.totalbags = totalbags;

        this.setState({
          order: res.data
        });
      })
      .catch((err) => {
        console.log(err, "error in Get Master Order");
      });
  }
}

function mapStateToProps(state) {
  return {
    ReceiptReducer: state.ReceiptReducer,
    oidc: state.oidc,
  };
}

export default connect(mapStateToProps)(ManualBagTags);
